(function () {
  'use strict';

  function init(notification) {
    if (notification.dataset.restockReady) return;
    notification.dataset.restockReady = 'true';
    var form = notification.querySelector('[data-restock-form]');
    var input = notification.querySelector('[data-rielli-notification-input]');
    var button = notification.querySelector('[data-restock-submit]');
    var status = notification.querySelector('[data-restock-status]');
    var label = notification.querySelector('[data-restock-variant]');
    var optIn = notification.querySelector('[data-restock-marketing]');
    var section = notification.closest('[data-section-type]') || notification.closest('.shopify-section');
    var siteId = notification.dataset.siteId;
    var listId = notification.dataset.listId;
    var buttonText = button.textContent;
    var busy = false;
    var variant = {
      id: notification.dataset.variantId,
      title: notification.dataset.variantTitle,
      available: notification.dataset.variantAvailable === 'true'
    };

    function message(text, error) {
      status.textContent = text;
      status.classList.toggle('rielli-notification__errors', Boolean(error));
      status.classList.toggle('rielli-notification__success', Boolean(text) && !error);
    }

    function sync() {
      label.textContent = notification.dataset.variantLabel.replace('__VARIANT__', variant.title || '');
      button.disabled = busy || !siteId || !variant.id || variant.available;
      input.disabled = busy;
      if (optIn) optIn.disabled = busy;
      button.textContent = busy ? notification.dataset.pending : buttonText;
      form.setAttribute('aria-busy', String(busy));
    }

    async function post(endpoint, data) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch('https://a.klaviyo.com/client/' + endpoint + '?company_id=' + encodeURIComponent(siteId), {
          method: 'POST',
          headers: {'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15'},
          body: JSON.stringify({data: data}),
          signal: controller.signal
        });
        if (response.status !== 202) throw new Error('Subscription not accepted');
      } finally {
        window.clearTimeout(timeout);
      }
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      if (!siteId) { message(notification.dataset.unavailable, true); return; }
      if (!variant.id || variant.available) { message(notification.dataset.selectVariant, true); return; }
      // Snapshot the requested variant so changes during the request cannot redirect the alert.
      var requested = {id: String(variant.id), title: variant.title};
      var email = input.value.trim();
      var marketing = Boolean(optIn && optIn.checked && listId);
      busy = true;
      sync();
      message('', false);
      try {
        await post('back-in-stock-subscriptions', {
          type: 'back-in-stock-subscription',
          attributes: {channels: ['EMAIL'], profile: {data: {type: 'profile', attributes: {email: email}}}},
          relationships: {variant: {data: {type: 'catalog-variant', id: '$shopify:::$default:::' + requested.id}}}
        });
        var result = notification.dataset.success.replace('__VARIANT__', requested.title);
        if (marketing) {
          try {
            await post('subscriptions', {
              type: 'subscription',
              attributes: {
                custom_source: 'Rielli restock form — optional marketing opt-in',
                profile: {data: {type: 'profile', attributes: {
                  email: email, subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
                }}}
              },
              relationships: {list: {data: {type: 'list', id: listId}}}
            });
            result += ' ' + notification.dataset.marketingSuccess;
          } catch (error) {
            result += ' ' + notification.dataset.marketingError;
          }
        }
        // A response for an earlier size must not be shown under the newly selected size.
        if (String(variant.id) === requested.id) message(result, false);
      } catch (error) {
        if (String(variant.id) === requested.id) message(notification.dataset.error, true);
      } finally {
        busy = false;
        sync();
      }
    });

    if (section) section.addEventListener('theme:variant:change', function (event) {
      // Ignore events for other product forms, such as a nested quick view.
      if (!event.target.contains(notification)) return;
      variant = (event.detail && event.detail.variant) || {id: '', title: '', available: true};
      message('', false);
      sync();
    });
    sync();
    if (!siteId) message(notification.dataset.unavailable, true);
  }

  function initAll(root) { root.querySelectorAll('[data-rielli-back-in-stock]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
